import React from "react";

const CloseX = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={11.23}
    height={11.23}
    viewBox="0 0 11.23 11.23"
    overflow="visible"
  >
    <style>
      {
        ".prefix__st0,.prefix__st1{fill:none;stroke:#ff2839;stroke-miterlimit:10}.prefix__st1{stroke:#fff;stroke-width:2}"
      }
    </style>
    <path
      className="prefix__st0"
      d="M.71 10.53L10.53.71M10.53 10.53L.71.71"
    />
    <g>
      <path
        className="prefix__st1"
        d="M.71 10.53L10.53.71M10.53 10.53L.71.71"
      />
    </g>
  </svg>
);

export default CloseX;
